module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "page",
    attrs: {
      "type": "flex",
      "gutter": 10,
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "login-form",
    attrs: {
      "xs": 14,
      "sm": 8,
      "md": 7,
      "lg": 6
    }
  }, [_c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/n2n.png")
    }
  })]), _vm._v(" "), _c('el-form', {
    staticClass: "login-form-form",
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    },
    model: {
      value: (_vm.loginData),
      callback: function($$v) {
        _vm.loginData = $$v
      },
      expression: "loginData"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": _vm.$l('login/Username')
    }
  }, [_c('el-input', {
    staticClass: "form-item",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.loginData.username),
      callback: function($$v) {
        _vm.$set(_vm.loginData, "username", $$v)
      },
      expression: "loginData.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": _vm.$l('login/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.loginData.password),
      callback: function($$v) {
        _vm.$set(_vm.loginData, "password", $$v)
      },
      expression: "loginData.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "button-item login-button"
  }, [_c('el-button', {
    attrs: {
      "native-type": "submit",
      "type": "primary"
    },
    on: {
      "click": _vm.loginSubmit
    }
  }, [_vm._v(_vm._s(_vm.$l('login/Login')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09fa8dde","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 442
// module chunks = 1